document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    const menu = document.getElementById(button.getAttribute('aria-controls'));
    if (!menu) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  });

  document.querySelectorAll('[data-carousel], [data-original-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track], [data-original-track]');
    if (!track) return;
    const move = (direction) => {
      const card = track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap || '14');
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    carousel.querySelector('[data-carousel-prev], [data-original-prev]')?.addEventListener('click', () => move(-1));
    carousel.querySelector('[data-carousel-next], [data-original-next]')?.addEventListener('click', () => move(1));
  });

  document.querySelectorAll('[data-product-filters]').forEach((filters) => {
    const section = filters.closest('.collection-content');
    const cards = Array.from(section?.querySelectorAll('[data-product-card]') || []);
    const count = filters.querySelector('[data-product-count]');
    filters.querySelectorAll('[data-product-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.productFilter;
        let visible = 0;
        filters.querySelectorAll('[data-product-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        cards.forEach((card) => {
          const show = filter === 'all' || card.dataset.category === filter;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = `${visible} soin${visible > 1 ? 's' : ''}`;
      });
    });
  });

  document.querySelectorAll('[data-bundle-selector]').forEach((selector) => {
    const productForm = selector.closest('form');
    const quantityInput = productForm?.querySelector('[data-bundle-quantity]');
    const purchaseTotal = productForm?.querySelector('[data-purchase-total]');
    const saving = selector.querySelector('[data-bundle-saving]');
    const productPage = selector.closest('.product-page');
    const stickyPrice = productPage?.querySelector('.mobile-sticky-add span');
    const options = Array.from(selector.querySelectorAll('[data-bundle-option]'));

    const selectOption = (input) => {
      if (!input || !quantityInput) return;
      quantityInput.value = input.value;
      options.forEach((option) => option.closest('.bundle-option')?.classList.toggle('is-selected', option === input));
      if (purchaseTotal) purchaseTotal.textContent = input.dataset.total || '';
      if (stickyPrice) stickyPrice.textContent = input.dataset.total || '';
      if (saving) saving.textContent = input.dataset.saving || '';
    };

    options.forEach((option) => option.addEventListener('change', () => selectOption(option)));
    selectOption(options.find((option) => option.checked) || options[0]);
  });

  document.querySelectorAll('[data-home-products-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-home-products-track]');
    const previous = carousel.querySelector('[data-home-products-previous]');
    const next = carousel.querySelector('[data-home-products-next]');
    const status = carousel.querySelector('[data-home-products-status]');
    const cards = Array.from(track?.children || []);
    if (!track || cards.length === 0) return;

    const currentIndex = () => {
      const firstWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap || '12');
      return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / (firstWidth + gap))));
    };

    const updateControls = () => {
      const index = currentIndex();
      if (status) status.textContent = `${index + 1} / ${cards.length}`;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index >= cards.length - 1;
    };

    const goTo = (index) => {
      const safeIndex = Math.max(0, Math.min(cards.length - 1, index));
      const firstWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap || '12');
      track.scrollTo({ left: safeIndex * (firstWidth + gap), behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => goTo(currentIndex() - 1));
    next?.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(currentIndex() + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let updateFrame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(updateControls);
    }, { passive: true });
    updateControls();
  });

  document.querySelectorAll('details[name]').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const group = details.getAttribute('name');
      document.querySelectorAll('details[name]').forEach((other) => {
        if (other !== details && other.getAttribute('name') === group) other.open = false;
      });
    });
  });
});
